import { endpoints, baseurl } from "../Utils/Constants";

export const getAllLocations = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_LOCATIONS, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching locations:", error);
        throw error;
    }
};

export const getLocationById = async (locationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_LOCATION_BY_ID + locationId, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    } catch (error) {
        console.error(`Error fetching location with ID ${locationId}:`, error);
        throw error;
    }
};

export const saveLocation = async (locationData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_LOCATION, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(locationData)
        });
        return await response.json();
    } catch (error) {
        console.error("Error saving location:", error);
        throw error;
    }
};

export const deleteLocation = async (locationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.DELETE_LOCATION + locationId, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    } catch (error) {
        console.error(`Error deleting location with ID ${locationId}:`, error);
        throw error;
    }
};

export const getLocationsByOrgId = async (orgId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_LOCATION_BY_ORG_ID + orgId, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    } catch (error) {
        console.error(`Error fetching locations for organization ID ${orgId}:`, error);
        throw error;
    }
};